module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tools.currentPaneKey === 'item') ? _c('div', {
    staticClass: "pane-template"
  }, [(!_vm.hideHeader) ? _c('pane-header', {
    attrs: {
      "title": _vm.item.title,
      "subtitle": _vm.item.sub,
      "tools": _vm.tools,
      "appIconKey": _vm.item.type,
      "hasCloseIcon": true
    }
  }) : _vm._e(), _vm._v(" "), _c('ui-scrollable-container', [_c('pane-content', [_c('ui-details', {
    attrs: {
      "title": _vm.item.name,
      "list": [{
          label: 'Status',
          value: _vm.item.status,
        },
        {
          label: 'Barcode',
          value: _vm.item.barcode,
        },
        {
          label: 'Loan type (permanent)',
          value: _vm.item.loan_type_permanent,
        },
        {
          label: 'Location (permanent)',
          value: _vm.item.location_type_permanent,
        },
        {
          label: 'Call Number',
          value: _vm.item.call_number,
        },
        {
          label: 'Material type',
          value: _vm.item.material_type,
        },
        {
          label: 'Loan type (temporary)',
          value: _vm.item.loan_type_temporary,
        },
        {
          label: 'Location (temporary)',
          value: _vm.item.location_type_temporary,
        } ]
    }
  }), _vm._v(" "), _c('pane-section', {
    attrs: {
      "title": "Related orders",
      "preset": "order",
      "itemCount": 1,
      "tools": _vm.tools
    }
  }), _vm._v(" "), _c('pane-section', {
    attrs: {
      "title": "Related instances",
      "itemCount": _vm.item.instanceCount,
      "preset": "instance",
      "tools": _vm.tools
    }
  })], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e207de3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pane-templates/ItemPaneTemplate.vue
// module id = 425
// module chunks = 1